"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _fileImage = _interopRequireDefault(require("@/components/fileImage.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _vuex = require("vuex");
var _user = require("@/api/user");
var _formatMixin = require("@/utils/formatMixin");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    FileImage: _fileImage.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    }
  }),
  data: function data() {
    return {
      shopList: this.$user.shopList,
      f_rate_q: 0,
      //计算订单服务费返点输入值
      f_rate_c: 0,
      //计算订单服务费返点计算值
      f_rate_r: 0,
      //计算订单服务费返点实际值

      p_rate_q: 0,
      //计算代理商订单服务费返点输入值
      p_rate_c: 0,
      //计算代理商订单服务费返点计算值
      p_rate_r: 0,
      //计算代理商订单服务费返点实际值
      pid: 0,
      document: {},
      attachments: [],
      listLoading: false,
      orderList: {
        count: 0
      },
      moneyList: {
        count: 0
      },
      // 充值余额流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      // 修改余额form
      accoutform: {
        sumcharge: '',
        recharge: 0 // 充值余额
      },
      // 余额提现form
      accoutform1: {
        sumcharge: '',
        withdrawal: 0 //提现余额
      },
      dialogVisibleAccount: false,
      //控制修改余额form
      dialogVisibleAccount1: false,
      //控制余额提现form
      dialogVisibleshop: false,
      // 控制修改商家信息form
      // 保存从服务器获取的修改收费form数据,开关数据也在里面，用于展示
      chargeform: {
        is_offline_rate: 0,
        //用户线下还款是否计算抽成金额
        is_offline_automatic: 0,
        //是否使用商户平台余额自动结算线下还款金额
        is_set_order: 1,
        //是否开启商户下单功能
        contract_money: '',
        // 合同费金额
        deposit_money: 50,
        bear_money: '',
        // 代扣手续费
        offline_bear_money: '',
        //线下还款手续费
        jd_withdrawal_rate: '',
        //京东提现抽成
        alipay_withdrawal_rate: '',
        //蚂蚁链提现抽成
        rate: '',
        // 订单服务费
        is_contract: '',
        //合同
        is_bear: '',
        //代扣
        is_hand: '',
        //1% 订单服务费
        is_day_nums: '',
        // 一天多期划扣模式
        is_test: '',
        // 测试模式
        pid: 0,
        f_contract_rate: 0,
        //合同费用抽成
        f_hand_rate: 0,
        //订单服务费返点
        f_bear_rate: 0,
        //划扣手续费费返点
        p_contract_rate: 0,
        //合同费用抽成
        p_hand_rate: 0,
        //订单服务费返点
        p_bear_rate: 0 //划扣手续费费返点
      },
      dialogVisibleCharge: false,
      //控制修改收费form,
      dialogVisibleChargeTwo: false,
      //控制修改返点form,
      dialogVisibleChargeThree: false,
      //控制修改返点form,
      // 以下为商家收费配置3个开关的值
      value1: true,
      value2: true,
      value3: true,
      // 收集修改收费form数据，提交给后端
      moneyform: {
        deposit_money: 50,
        //店铺保障金
        contract_money: '',
        // 合同费金额
        bear_money: '',
        // 代扣手续费
        offline_bear_money: '',
        //线下还款手续费
        jd_withdrawal_rate: '',
        //京东提现抽成
        alipay_withdrawal_rate: '',
        //蚂蚁链提现抽成
        rate: '',
        // 订单服务费
        f_contract_rate: 0,
        //合同费用抽成
        f_hand_rate: 0,
        //订单服务费返点
        f_bear_rate: 0,
        //划扣手续费费返点
        p_contract_rate: 0,
        //合同费用抽成
        p_hand_rate: 0,
        //订单服务费返点
        p_bear_rate: 0 //划扣手续费费返点
      },
      // 商家基础信息
      shopInfo: {},
      // 修改商家基础信息form
      shopform: {
        company_name: '',
        address: '',
        scc: '',
        product_name: '',
        email: '',
        status: '',
        alipay: '',
        sealId: '',
        aa_id: '',
        bb_id: '',
        cc_id: '',
        mobile: ''
      },
      isRequesting: false,
      // 控制按钮是否禁用的标志位
      lastExecutedTime: 0,
      // 上次执行的时间
      dialogWidth: window.innerWidth < 768 ? '90%' : '30%',
      // 弹窗宽度
      dialogLabelWidth: window.innerWidth < 768 ? '100px' : '150px',
      // 弹窗标签宽度
      descriptionsColumn: window.innerWidth < 768 ? 1 : 3 // 描述列数
    };
  },
  created: function created() {
    var _this = this;
    this.$user.getShopList().then(function (resp) {
      _this.shopList = resp;
      //   this.value =  Number(this.$user.data.shop) 
    });
    this.pk = this.$route.query.id;
    // 获取商家数据
    this.getList();
    this.getList1();
    // 获取充值余额流水
    this.getMoneyList();
    // 获取商家收费配置数据
    this.getCharge();
  },
  methods: {
    // 获取商家信息数据——done
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/Shop/".concat(this.pk, "/"),
        method: 'get'
      }).then(function (response) {
        if (response.data) {
          _this2.document = response.data;
          // this.shopform = response.data
          // 获取商家余额
          _this2.getMoney();
        }
        _this2.listLoading = false;
      });
      // 获取商家照片
      (0, _request.default)({
        url: "/ShopFile/",
        method: 'get',
        params: {
          'shop': this.pk
        }
      }).then(function (response) {
        if (response.data) {
          _this2.attachments = response.data.results;
        }
      });
    },
    // 获取商家信息数据——新接口
    getList1: function getList1() {
      var _this3 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/customer/getInfoAll/",
        method: 'get',
        params: {
          shop_id: this.pk
        }
      }).then(function (res) {
        _this3.shopInfo = res.data;
        _this3.shopform.company_name = res.data.company_name;
        _this3.shopform.address = res.data.address;
        _this3.shopform.scc = res.data.scc;
        _this3.shopform.product_name = res.data.product_name;
        _this3.shopform.email = res.data.email;
        _this3.shopform.status = res.data.status;
        _this3.shopform.alipay = res.data.customer.alipay;
        _this3.shopform.sealId = res.data.customer.sealId;
        _this3.shopform.mobile = res.data.mobile;
        _this3.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleFilter: function handleFilter() {
      this.getList();
    },
    // 页头--返回上级页面——done
    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取商家余额——done
    getMoney: function getMoney() {
      var _this4 = this;
      (0, _request.default)({
        url: "/Customer/".concat(this.document.customer, "/"),
        method: 'get',
        params: {
          shop: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          _this4.accoutform.sumcharge = response.data.real_money;
          _this4.accoutform1.sumcharge = response.data.real_money;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 获取余额流水——done
    getMoneyList: function getMoneyList() {
      var _this5 = this;
      this.listLoading = true;
      // 王工封装
      // type 1为充值余额流水  type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/order/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.pk,
          type: 1,
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          is_pay: 1
        }
      }).then(function (response) {
        if (response.data) {
          _this5.moneyList = response.data.data;
        }
        _this5.listLoading = false;
      });
    },
    // 修改余额保存，加限制——done
    onSubmitAccount: function onSubmitAccount() {
      var _this6 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform.recharge < 1) {
          this.$message.error('最少1元');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/money/",
          method: 'put',
          data: {
            shop_id: this.pk,
            customer: this.document.customer,
            money: this.accoutform.recharge
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this6.dialogVisibleAccount = false;
            _this6.accoutform.recharge = 0;
            _this6.getList(); //重新获取数据
            _this6.getMoneyList(); // 重新获取充值余额流水
            _this6.isRequesting = false; // 启用按钮
            _this6.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    },
    // 余额提现保存，加限制——done
    onSubmitAccount1: function onSubmitAccount1() {
      var _this7 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform1.withdrawal < 1) {
          this.$message.error('最少1元');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/moneyDec/",
          method: 'put',
          data: {
            shop_id: this.pk,
            customer: this.document.customer,
            money: this.accoutform1.withdrawal
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this7.dialogVisibleAccount1 = false;
            _this7.accoutform.withdrawal = 0;
            _this7.getList(); //重新获取数据
            _this7.getMoneyList(); // 重新获取充值余额流水
            _this7.isRequesting = false; // 启用按钮
            _this7.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    },
    // 获取商家收费配置数据——done
    getCharge: function getCharge() {
      var _this8 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          // shop_id: this.$user.data.shop,
          shop_id: this.pk
        }
      }).then(function (response) {
        if (response.data) {
          _this8.chargeform = response.data;
          _this8.pid = response.data.pid;
          _this8.moneyform.contract_money = response.data.contract_money;
          _this8.moneyform.bear_money = response.data.bear_money;
          _this8.moneyform.deposit_money = response.data.deposit_money;
          _this8.moneyform.jd_withdrawal_rate = response.data.jd_withdrawal_rate;
          _this8.moneyform.alipay_withdrawal_rate = response.data.alipay_withdrawal_rate;
          _this8.moneyform.offline_bear_money = response.data.offline_bear_money;
          _this8.moneyform.rate = response.data.rate;
          _this8.moneyform.f_contract_rate = response.data.f_contract_rate;
          _this8.moneyform.f_hand_rate = response.data.f_hand_rate;
          _this8.moneyform.f_bear_rate = response.data.f_bear_rate;
          _this8.moneyform.p_contract_rate = response.data.p_contract_rate;
          _this8.moneyform.p_hand_rate = response.data.p_hand_rate;
          _this8.moneyform.p_bear_rate = response.data.p_bear_rate;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 修改收费保存——done
    onSubmitCharge: function onSubmitCharge() {
      var _this9 = this;
      if (parseInt(this.moneyform.f_contract_rate) + parseInt(this.moneyform.p_contract_rate) > parseInt(this.moneyform.contract_money)) {
        this.$message.error('返点金额不可大于合同费用1');
      } else {
        if (parseInt(this.moneyform.f_hand_rate) + parseInt(this.moneyform.p_hand_rate) >= 100) {
          this.$message.error('服务费返点不能大于100%');
        } else {
          if (parseInt(this.moneyform.f_bear_rate) + parseInt(this.moneyform.p_bear_rate) >= parseInt(this.moneyform.bear_money) && parseInt(this.moneyform.bear_money) > 0) {
            this.$message.error('划扣返点不能大于订单划扣返点' + (parseInt(this.moneyform.f_bear_rate) + parseInt(this.moneyform.p_bear_rate)));
          } else {
            (0, _request.default)({
              url: "/system/shopConfig/updateConfig/",
              method: 'put',
              data: {
                shop_id: this.pk,
                field: 'value',
                value: JSON.stringify(this.moneyform)
              }
            }).then(function (response) {
              if (response.code == 200) {
                _this9.dialogVisibleCharge = false;
                _this9.getCharge(); //重新获取数据
              }
            }).catch(function (error) {
              console.log(error);
            });
          }
        }
        // 提交数据给后端
      }
    },
    // 修改收费保存——done
    onSubmitChargeTwo: function onSubmitChargeTwo() {
      var _this10 = this;
      console.log(this.moneyform.f_contract_rate);
      console.log(this.moneyform.p_contract_rate);
      console.log(this.moneyform.contract_money);
      if (parseInt(this.moneyform.f_contract_rate) + parseInt(this.moneyform.p_contract_rate) > parseInt(this.moneyform.contract_money)) {
        this.$message.error('返点金额不可大于合同费用2');
      } else {
        if (parseInt(this.moneyform.f_hand_rate) + parseInt(this.moneyform.p_hand_rate) >= 100) {
          this.$message.error('服务费返点不能大于100%');
        } else {
          if (parseInt(this.moneyform.f_bear_rate) + parseInt(this.moneyform.p_bear_rate) >= parseInt(this.moneyform.bear_money) && parseInt(this.moneyform.bear_money) > 0) {
            this.$message.error('划扣返点不能大于订单划扣返点');
          } else {
            (0, _request.default)({
              url: "/system/shopConfig/updateConfigTwo/",
              method: 'put',
              data: {
                shop_id: this.pk,
                field: 'value',
                value: JSON.stringify(this.moneyform)
              }
            }).then(function (response) {
              if (response.code == 200) {
                _this10.dialogVisibleChargeTwo = false;
                _this10.getCharge(); //重新获取数据
              }
            }).catch(function (error) {
              console.log(error);
            });
          }
        }
      }
      // 提交数据给后端
    },
    // 修改收费保存——done
    onSubmitChargeThree: function onSubmitChargeThree() {
      var _this11 = this;
      if (parseInt(this.moneyform.f_contract_rate) + parseInt(this.moneyform.p_contract_rate) > parseInt(this.moneyform.contract_money)) {
        this.$message.error('返点金额不可大于合同费用3');
      } else {
        if (parseInt(this.moneyform.f_hand_rate) + parseInt(this.moneyform.p_hand_rate) >= 100) {
          this.$message.error('服务费返点不能大于100%');
        } else {
          if (parseInt(this.moneyform.f_bear_rate) + parseInt(this.moneyform.p_bear_rate) >= parseInt(this.moneyform.bear_money) && parseInt(this.moneyform.bear_money) > 0) {
            this.$message.error('划扣返点不能大于订单划扣返点');
          } else {
            (0, _request.default)({
              url: "/system/shopConfig/updateConfigThree/",
              method: 'put',
              data: {
                shop_id: this.pk,
                field: 'value',
                value: JSON.stringify(this.moneyform)
              }
            }).then(function (response) {
              if (response.code == 200) {
                _this11.dialogVisibleChargeThree = false;
                _this11.getCharge(); //重新获取数据
              }
            }).catch(function (error) {
              console.log(error);
            });
          }
        }
      }
      // 提交数据给后端
    },
    // 收费开关1change——done
    item1Change: function item1Change(e) {
      var _this12 = this;
      // 1.修改开关的值
      this.chargeform.is_contract = e;
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          // shop_id: this.$user.data.shop,
          shop_id: this.pk,
          field: 'is_contract',
          value: this.chargeform.is_contract
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this12.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 收费开关2change——done
    item3Change: function item3Change(e) {
      var _this13 = this;
      // 1.修改开关的值
      this.chargeform.is_bear = e;
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'is_bear',
          value: this.chargeform.is_bear
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this13.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 收费开关3change——done
    item2Change: function item2Change(e) {
      var _this14 = this;
      // 1.修改开关的值
      this.chargeform.is_hand = e;
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'is_hand',
          value: this.chargeform.is_hand
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this14.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    item4Change: function item4Change(e) {
      var _this15 = this;
      // 1.修改开关的值
      this.chargeform.is_day_nums = e;
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'is_day_nums',
          value: this.chargeform.is_day_nums
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this15.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    item6Change: function item6Change() {
      var _this16 = this;
      // 1.修改开关的值
      //   this.chargeform.pid = this.pid
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'pid',
          value: this.pid
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this16.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getRateC: function getRateC() {
      this.f_rate_c = parseInt(parseInt(this.f_rate_q * 10000 / this.moneyform.rate) / 100);
      if (this.f_rate_c >= 100) {
        this.$message.error('百分比大于100');
      } else {
        this.f_rate_r = this.f_rate_c * this.moneyform.rate / 100;
        this.moneyform.f_hand_rate = this.f_rate_c;
      }
    },
    getRateD: function getRateD() {
      this.p_rate_c = parseInt(parseInt(this.p_rate_q * 10000 / this.moneyform.rate) / 100);
      if (this.p_rate_c >= 100) {
        this.$message.error('百分比大于100');
      } else {
        this.p_rate_r = this.p_rate_c * this.moneyform.rate / 100;
        this.moneyform.p_hand_rate = this.p_rate_c;
      }
    },
    item5Change: function item5Change(e) {
      var _this17 = this;
      // 1.修改开关的值
      this.chargeform.is_test = e;
      // 2.提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'is_test',
          value: this.chargeform.is_test
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this17.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusChange: function statusChange(e) {
      var _this18 = this;
      this.chargeform.is_offline_rate = e;
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: "is_offline_rate",
          value: this.chargeform.is_offline_rate
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this18.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    status1Change: function status1Change(e) {
      var _this19 = this;
      this.chargeform.is_offline_automatic = e;
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: "is_offline_automatic",
          value: this.chargeform.is_offline_automatic
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this19.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    status2Change: function status2Change(e) {
      var _this20 = this;
      this.chargeform.is_set_order = e;
      (0, _request.default)({
        url: "/system/shopConfig/updateConfig/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: "is_set_order",
          value: this.chargeform.is_set_order
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this20.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 修改商家信息保存——done
    onSubmitShop: function onSubmitShop() {
      var _this21 = this;
      // 提交数据给后端
      (0, _request.default)({
        url: "/system/customer/updateInfo/",
        method: 'put',
        data: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
          alipay: this.shopform.alipay,
          company_name: this.shopform.company_name,
          address: this.shopform.address,
          scc: this.shopform.scc,
          product_name: this.shopform.product_name,
          email: this.shopform.email,
          status: this.shopform.status
        }, "alipay", this.shopform.alipay), "sealId", this.shopform.sealId), "aa_id", this.shopform.aa_id), "bb_id", this.shopform.bb_id), "cc_id", this.shopform.cc_id), "shop_id", this.pk), "mobile", this.shopform.mobile)
      }).then(function (response) {
        if (response.code == 200) {
          _this21.dialogVisibleshop = false;
          _this21.getList1(); //重新获取商家数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};